import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const PrintGoodsReport: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.PRINT_REPORT_ALL_GOODS,
            value: value ? '1' : '0',
          })
        }
        value={settings.printReportAllGoods}
        label={t('settings.print.goods.title')}
        description={t('settings.print.goods.description')}
        variant="secondary"
        emptyBg
      />
    </>
  );
};
